/**
 * Created with IntelliJ IDEA.
 * User: snikic
 * Date: 02/22/2016
 * Time: 7:31 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var CP_CONST = require("connection-const");
    var MessagingNotoficationsCollection = require("connection-collections/chatTab/MessagingNotificationsCollection");
    var AuthenticationModel = require("connection-models/chatTab/AuthenticationModel");

    var MessagingNotificationsController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        MessagingNotificationsController = Marionette.Controller.extend({
            initialize: function (options) {

                logger.debug("initializing", "MessagingNotificationsController:initialize");
                options = options || {};
                this._contextModel = options.contextModel;
                this._notificationVent = LEConnection.media.channel(LE.mediaCodes.connection.channels.NOTIFICATION_TAB).vent;
                this._chatVent = options.chatChannel.vent;
                this.notificationsCollection = new MessagingNotoficationsCollection([], {chatVent: this._chatVent});
                this._iframeState = CP_CONST.CONVERSATION_IFRAME_STATE.NONE;
                this._bindEvents();
            },

            _bindEvents: function () {
                this.listenTo(this.notificationsCollection, "sync add change set", this._updateNotificationsCounter, this);
                this.listenTo(this._contextModel, "change:contacts", this._onContactsInitialized, this);
                this.listenTo(this._chatVent, "cpChatUI:display:messagingFrame", function(model){
                    this._iframeState = CP_CONST.CONVERSATION_IFRAME_STATE.MESSAGING;
                    model.resetNotificationsCounter();
                }, this);
                this.listenTo(this._chatVent, "chatConnection:chat:close", function () {
                    this._iframeState = CP_CONST.CONVERSATION_IFRAME_STATE.NONE;
                }, this);
                this.listenTo(this._notificationVent, "messaging:receivedUnreadNotification", function (data) {
                    this.notificationsCollection.set(data, {remove:true});
                },this);
                this.listenTo(this._notificationVent, "socketAPI:notSupported", this._initRestFallback, this);
                // with this we can receive notifications for new account
                this.listenTo(LE.vent, "LPTagConfigModel:config:changed", this._onLPTagConfigChange);
            },

            _onLPTagConfigChange: function() {
                this.notificationsCollection.reset();
                this._onContactsLoaded();
            },

            _onContactsInitialized: function () {
                if (this._contextModel.getContacts()) {
                    this.listenTo(this._contextModel.getContacts(), "sync", this._onContactsLoaded, this);
                }
            },

            _onContactsLoaded: function () {
                var messagingContacts = this._contextModel.getContacts().getMessagingContacts();
                if (messagingContacts) {
                    this._msgContactsAmount = messagingContacts.length;
                    logger.debug('found '.concat(this._msgContactsAmount).concat(' messaging contacts, loading LpJWTs...'));
                    _.each(messagingContacts, _.bind(this._getLpJWTForSingleContact, this));
                }
            },

            _getLpJWTForSingleContact: function (contactModel) {
                logger.debug('started loading jwt for '.concat(contactModel.getSkillName()), 'MessagingNotificationsController._getLpJWTForSingleContact');
                var authenticationAttributes = {
                    skillName: contactModel.getSkillName(),
                    isPSGContact: contactModel.isPSGContact()
                };
                var authModel = new AuthenticationModel(authenticationAttributes);
                authModel.fetch({
                    success: _.bind(this._onJWTLoaded, this),
                    error: function (model, response) {
                        logger.error('could not load jwt from cp backend', 'MessagingNotificationsController._getLpJWTForSingleContact', response);
                    }
                });
            },

            _onJWTLoaded: function (authModel) {
                logger.debug('started loading lpjwt for '.concat(authModel.getSkillName()), 'MessagingNotificationsController._onJWTLoaded');
                authModel.fetch({
                    success: _.bind(this._onLpJWTLoaded, this),
                    error: function (model, response) {
                        logger.error('could not load LpJWT from IDP', 'MessagingNotificationsController._onJWTLoaded',response);
                    }
                });
            },

            _onLpJWTLoaded: function (authModel) {
                logger.debug('success loading lpjwt for '.concat(authModel.getSkillName()).concat(', jwt: ').concat(authModel.getJWT()), 'MessagingNotificationsController._onLpJWTLoaded');
                this.notificationsCollection.add({
                    skillName: authModel.getSkillName(),
                    sub: this._getSubscriberId(authModel.getJWT())
                });

                // if we have a lpjwt for each msg contact, we can now start querying our backend for unread messages
                if (this.notificationsCollection.length === this._msgContactsAmount) {
                    var payload = this.notificationsCollection.getRequestPayload();
                    this._notificationVent.trigger('messaging:subscribeForUnreadMessages', payload);
                }
            },

            _getSubscriberId: function (jwt) {
                return this._getJWTPayload(jwt).sub;
            },

            _getJWTPayload: function (jwt) {
                var base64Url = jwt.split('.')[1];
                var base64 = base64Url.replace('-', '+').replace('_', '/');
                return JSON.parse(window.atob(base64));
            },

            _updateNotificationsCounter: function () { //use this method when we are done with the initial calculation
                logger.debug("notifications query received", "MessagingNotificationsController:_updateNotificationsCounter");
                //iterate over all models in the notification collection and update counter if it is > 0
                _.each(this.notificationsCollection.models, this._evaluateNotificationsCounter, this);
            },

            _evaluateNotificationsCounter: function (notificationsModel) {
                var unreadMessages = notificationsModel.getUnreadMessages();
                var skillName = notificationsModel.getSkillName();
                logger.debug("received ".concat(unreadMessages).concat(" unread messages for skillname: ").concat(skillName), "MessagingNotificationsController:_evaluateNotificationsCounter");
                if (this._iframeState !== CP_CONST.CONVERSATION_IFRAME_STATE.MESSAGING) {
                    this._chatVent.trigger('messaging:notificationsChanged', skillName, unreadMessages);
                }
            },

            _initRestFallback: function () {
                this.notificationsCollection.initConnection();
            }
        });


    });

    return MessagingNotificationsController;
});

